import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  booleanAttribute,
  computed,
  input
} from '@angular/core';
import { OSKColorVariant, OSKIconName, OSKSize } from '../../types/osk-theme.types';
import { OSKIconComponent } from '../osk-icon/osk-icon.component';

export type OSKBadgeAppearance = 'soft' | 'solid' | 'outline';

/**
 * Atom: <osk-badge>
 * Tag / pill badge built with Angular Signals.
 */
@Component({
  selector: 'osk-badge',
  standalone: true,
  imports: [OSKIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './osk-badge.component.scss',
  template: `
    <span [class]="badgeClasses()">
      @if (leadingIcon()) {
        <osk-icon [name]="leadingIcon()!" [size]="iconSize()"></osk-icon>
      }
      <ng-content></ng-content>
    </span>
  `
})
export class OSKBadgeComponent {
  readonly color = input<OSKColorVariant>('neutral');
  readonly appearance = input<OSKBadgeAppearance>('soft');
  readonly size = input<OSKSize>('md');
  readonly pill = input(false, { transform: booleanAttribute });
  readonly leadingIcon = input<OSKIconName | undefined>(undefined);

  protected readonly iconSize = computed<number>(() => {
    switch (this.size()) {
      case 'sm':
        return 12;
      case 'lg':
        return 16;
      default:
        return 14;
    }
  });

  protected readonly badgeClasses = computed<string>(() => {
    const classes: string[] = [
      'osk-badge',
      `osk-badge--${this.color()}`,
      `osk-badge--${this.appearance()}`,
      `osk-badge--${this.size()}`
    ];
    if (this.pill()) {
      classes.push('osk-badge--pill');
    }
    return classes.join(' ');
  });
}
